import React, { useEffect } from 'react'

export default function TON() {
  useEffect(() => {
    if (window.Swiper) {
      new window.Swiper(".tonSlider", {
        slidesPerView: 1,
        spaceBetween: 50,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".ton-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".ton-next",
          prevEl: ".ton-prev",
        },
      });
    }
  }, []);

  return (
    <div className="agn-ton-wrapper">
      <style>{`
   
        .agn-ton-wrapper {
          padding: var(--section-padding);
          background: #fdfdfd;
          position: relative;
          overflow: hidden;
        }

        .ton-header {
          text-align: center;
          margin-bottom: var(--margin-title);
        }

        .ton-header h2 {
          font-family: var(--font-primary);
          font-size: var(--h2-size);
          font-weight: var(--h2-weight);
          color: var(--theme-color);
          margin-bottom: 20px;
          letter-spacing: -0.02em;
        }

        .ton-header p {
          font-family: var(--font-secondary);
          max-width: 750px;
          margin: 0 auto;
          color: #666;
          font-size: var(--body-size);
          line-height: var(--lh-base);
        }

        .ton-slider-outer {
          max-width: 1300px;
          margin: 0 auto;
          position: relative;
          padding: 0 80px;
        }

        .tonSlider {
          border-radius: 40px;
          background: #ffffff;
          box-shadow: 0 30px 80px rgba(0, 0, 0, 0.05);
          border: 1px solid rgba(0, 0, 0, 0.03);
          overflow: hidden;
        }

        .ton-slide-content {
          padding: 60px;
          display: flex;
          align-items: center;
          gap: 50px;
          min-height: 550px;
        }

        .ton-visual-part {
          flex: 0 0 45%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .ton-visual-part::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          background: radial-gradient(circle, rgba(var(--theme-color-rgb), 0.07) 0%, transparent 70%);
          z-index: 0;
        }

        .ton-visual-part img {
          width: 100%;
          max-width: 450px;
          height: auto;
          position: relative;
          z-index: 1;
          filter: drop-shadow(0 20px 40px rgba(0,0,0,0.1));
          transition: transform 0.6s ease;
        }

        .swiper-slide-active .ton-visual-part img {
          transform: scale(1.05);
        }

        .ton-text-part {
          flex: 1;
          text-align: left;
        }

        .mechanism-tag {
          display: inline-block;
          font-family: var(--font-primary);
          font-size: var(--label-size);
          font-weight: var(--label-weight);
          color: var(--theme-color);
          text-transform: uppercase;
          letter-spacing: 3px;
          margin-bottom: 15px;
          position: relative;
          padding-left: 40px;
        }

        .mechanism-tag::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          width: 30px;
          height: 2px;
          background: var(--theme-color);
        }

        .ton-text-part h3 {
          font-family: var(--font-primary);
          font-size: var(--h3-size);
          font-weight: 850;
          color: #111;
          margin-bottom: 25px;
          line-height: var(--lh-tight);
        }

        .ton-intro-text {
          font-family: var(--font-secondary);
          font-size: var(--small-size);
          color: #555;
          line-height: var(--lh-base);
          margin-bottom: 30px;
        }

        .ton-feature-points {
          list-style: none;
          padding: 0;
          margin: 0 0 35px 0;
        }

        .ton-feature-points li {
          display: flex;
          align-items: center;
          gap: 15px;
          font-family: var(--font-secondary);
          font-size: var(--small-size);
          font-weight: 600;
          color: #333;
          margin-bottom: 12px;
        }

        .ton-feature-points li i {
          color: var(--theme-color);
          font-size: 1.1rem;
        }

        .how-box {
          background: rgba(var(--theme-color-rgb), 0.04);
          border-radius: 20px;
          padding: 25px;
          border: 1px solid rgba(var(--theme-color-rgb), 0.1);
          margin-bottom: 35px;
          position: relative;
        }

        .how-box h4 {
          font-family: var(--font-primary);
          font-size: 0.9rem;
          font-weight: 900;
          color: var(--theme-color);
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: 10px;
        }

        .how-box p {
          font-family: var(--font-secondary);
          font-size: var(--small-size);
          color: #555;
          margin: 0;
          line-height: var(--lh-base);
        }

        .ton-benefit-row {
          display: flex;
          flex-wrap: wrap;
          gap: 15px;
        }

        .benefit-pill {
          background: #f8f9fa;
          border: 1px solid rgba(0,0,0,0.05);
          padding: 10px 20px;
          border-radius: 100px;
          font-family: var(--font-primary);
          font-size: 0.85rem;
          font-weight: 700;
          color: #444;
          display: flex;
          align-items: center;
          gap: 10px;
          transition: all 0.3s ease;
        }

        .benefit-pill:hover {
          background: #ffffff;
          border-color: var(--theme-color);
          color: var(--theme-color);
          transform: translateY(-3px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.05);
        }

        .benefit-pill i {
          color: var(--theme-color);
        }

        /* Nav Buttons */
        .ton-nav-btn {
          width: 54px;
          height: 54px;
          background: #ffffff;
          border: 1px solid rgba(0, 0, 0, 0.08);
          border-radius: 50%;
          color: #111;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 10;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        }

        .ton-nav-btn:hover {
          background: var(--theme-color);
          color: #ffffff;
          border-color: var(--theme-color);
          transform: translateY(-50%) scale(1.1);
        }

        .ton-prev { left: 0; }
        .ton-next { right: 0; }

        .ton-pagination {
          margin-top: 40px !important;
          position: static !important;
        }

        .ton-pagination .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          background: rgba(0,0,0,0.1);
          opacity: 1;
        }

        .ton-pagination .swiper-pagination-bullet-active {
          background: var(--theme-color) !important;
          width: 30px;
          border-radius: 5px;
        }

        @media (max-width: 1100px) {
          .ton-slide-content {
            flex-direction: column;
            padding: 40px;
            text-align: center;
          }
          .ton-text-part { text-align: center; }
          .mechanism-tag { padding-left: 0; }
          .mechanism-tag::before { display: none; }
          .ton-feature-points { display: inline-block; text-align: left; }
          .ton-benefit-row { justify-content: center; }
        }

        @media (max-width: 767px) {
          .ton-slider-outer { padding: 0; }
          .ton-nav-btn { display: none; }
        }
      `}</style>

      <div className="container">
        <div className="ton-header">
          <h2>
            How AGN’s Financial Model Works

          </h2>
          <p>

            AGN operates through a multi-layered financial ecosystem that combines real-world utility, digital assets, and market-driven mechanisms to generate sustainable income opportunities.


          </p>
        </div>

        <div className="ton-slider-outer">
          <div className="swiper tonSlider">
            <div className="swiper-wrapper">
              {/* Slide 1 */}
              <div className="swiper-slide">
                <div className="ton-slide-content">
                  <div className="ton-visual-part">
                    <img src="assets/images/img/blockchain_infrastructure.png" alt="Blockchain" />
                  </div>
                  <div className="ton-text-part">
                    <span className="mechanism-tag"> 01</span>
                    <h3>

                      Blockchain Infrastructure (Transparency & Security)

                    </h3>
                    <p className="ton-intro-text">
                      AGN leverages blockchain technology to ensure:

                    </p>
                    <ul className="ton-feature-points">
                      <li><i className="fa-solid fa-circle-check"></i> Transparent transaction records
                      </li>
                      <li><i className="fa-solid fa-circle-check"></i>
                        Secure asset tracking

                      </li>
                      <li><i className="fa-solid fa-circle-check"></i>
                        Decentralized verification of activities
                      </li>
                    </ul>
                    <div className="how-box">
                      <h4>How it works:
                      </h4>
                      <p>
                        All major transactions and allocations are recorded through secure digital ledgers, improving trust and operational efficiency.
                      </p>
                    </div>
                    <div className="ton-benefit-row">
                      <div className="benefit-pill"><i className="fa-solid fa-shield-halved"></i>Tamper-proof system
                      </div>
                      <div className="benefit-pill"><i className="fa-solid fa-users"></i> Enhanced trust & accountability
                      </div>
                      <div className="benefit-pill"><i className="fa-solid fa-globe"></i> Global accessibility
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Slide 2 */}
              <div className="swiper-slide">
                <div className="ton-slide-content">
                  <div className="ton-visual-part">
                    <img src="assets/images/img/travel_platform_integration.png" alt="Travel" />
                  </div>
                  <div className="ton-text-part">
                    <span className="mechanism-tag"> 02</span>
                    <h3>
                      Travel Platform Integration (Real Utility Engine)

                    </h3>
                    <p className="ton-intro-text">
                      AGN connects with a global travel ecosystem, enabling revenue generation through:

                    </p>
                    <ul className="ton-feature-points">
                      <li><i className="fa-solid fa-circle-check"></i> Hotel bookings and travel services</li>
                      <li><i className="fa-solid fa-circle-check"></i> Commission-based earnings from user activity
                      </li>
                      <li><i className="fa-solid fa-circle-check"></i> Real-world cash flow backed by tourism demand
                      </li>
                    </ul>
                    <div className="how-box">
                      <h4>How it works:
                      </h4>
                      <p>
                        User engagement in travel services generates transaction-based revenue, which contributes to the overall income pool.

                      </p>
                    </div>
                    <div className="ton-benefit-row">
                      <div className="benefit-pill"><i className="fa-solid fa-briefcase"></i> Real-world business backing
                      </div>
                      <div className="benefit-pill"><i className="fa-solid fa-chart-line"></i> Continuous demand-driven income
                      </div>
                      <div className="benefit-pill"><i className="fa-solid fa-money-bill-transfer"></i>Utility-based financial flow
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Slide 3 */}
              <div className="swiper-slide">
                <div className="ton-slide-content">
                  <div className="ton-visual-part">
                    <img src="assets/images/img/nft_marketplace.png" alt="NFT" />
                  </div>
                  <div className="ton-text-part">
                    <span className="mechanism-tag"> 03</span>
                    <h3>NFT Marketplace (Digital Asset Economy)
                    </h3>
                    <p className="ton-intro-text">AGN introduces an NFT-based asset layer where:
                    </p>
                    <ul className="ton-feature-points">
                      <li><i className="fa-solid fa-circle-check"></i> Digital assets represent participation or utility rights
                      </li>
                      <li><i className="fa-solid fa-circle-check"></i> NFTs can be traded or utilized within the ecosystem</li>
                      <li><i className="fa-solid fa-circle-check"></i>Value is driven by platform activity and demand
                      </li>
                    </ul>
                    <div className="how-box">
                      <h4>How it works:
                      </h4>
                      <p> Users may acquire or interact with NFTs that are linked to platform benefits, access, or rewards, creating an additional income dimension.
                      </p>
                    </div>
                    <div className="ton-benefit-row">
                      <div className="benefit-pill"><i className="fa-solid fa-gem"></i> Ownership of digital assets</div>
                      <div className="benefit-pill"><i className="fa-solid fa-bolt"></i>  Marketplace-driven value creation
                      </div>
                      <div className="benefit-pill"><i className="fa-solid fa-microchip"></i>  Expanding digital economy
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="swiper-pagination ton-pagination"></div>

          <div className="ton-nav-btn ton-prev">
            <i className="fa-solid fa-chevron-left"></i>
          </div>
          <div className="ton-nav-btn ton-next">
            <i className="fa-solid fa-chevron-right"></i>
          </div>
        </div>
      </div>
    </div>
  )
}
